import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import shareIcon from '../../assets/share.svg'
import closeIcon from '../../assets/close.svg'
import facebookIcon from '../../assets/facebook.svg'
import twitterIcon from '../../assets/twitter.svg'
import emailIcon from '../../assets/email.svg'
import smsIcon from '../../assets/sms.svg'


export default class ShareButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isEnabled: false
    }
  }

  componentDidMount () {
    this.props.setShareButtonsVisible(0)
  }

  handleMainButtonClick = () => {
    if (this.state.isEnabled) {
      this.props.setShareButtonsVisible(0)
    } else {
      this.props.setShareButtonsVisible(1)
    }
    this.setState({ isEnabled: !this.state.isEnabled })
  }

  goToUrl (url) {
    if (url) {
      window.location.href = url
    }
  }

  render () {
    const { facebook, twitter, email, phone, shareTitle, shareSubtitle } = this.props
    return (
      <CSSTransitionGroup
        transitionName='co_share'
        transitionEnterTimeout={750}
        transitionLeaveTimeout={750}
      >
        <div id='co_share__main-button' className='co_share__main-button' onClick={this.handleMainButtonClick}>
          <CSSTransitionGroup
            transitionName='co_share'
            transitionEnterTimeout={750}
            transitionLeaveTimeout={750}
          >
            {(this.state.isEnabled)
              ? <div className='co_share__main-button-icon-close' style={{ backgroundImage: `url(${closeIcon})` }} key={0} />
              : <div className='co_share__main-button-icon-share' style={{ backgroundImage: `url(${shareIcon})` }} key={1} />
            }
          </CSSTransitionGroup>
        </div>

        {/*{this.state.isEnabled &&*/}
        {/**/}
        {/*}*/}
        <div className={`co_share co_share__bg ${this.state.isEnabled ? 'co_share__in' : 'co_share__out'}`} key='share'>
          <div id='co_share__title' className='co_share__title'>{shareTitle}</div>
          <div id='co_share__subtitle' className='co_share__subtitle'>{shareSubtitle}</div>
          <div className='co_share__buttons'>
            <div id='co_share__button--facebook' className='co_share__button co_share__button--facebook' onClick={() => this.goToUrl(facebook)}>
              <div className='co_share__button-icon' style={{ backgroundImage: `url(${facebookIcon})` }} />
            </div>
            <div id='co_share__button--twitter' className='co_share__button co_share__button--twitter' onClick={() => this.goToUrl(twitter)}>
              <div className='co_share__button-icon' style={{ backgroundImage: `url(${twitterIcon})` }} />
            </div>
            <div id='co_share__button--email' className='co_share__button co_share__button--email' onClick={() => this.goToUrl(`mailto:${email}`)}>
              <div className='co_share__button-icon' style={{ backgroundImage: `url(${emailIcon})` }} />
            </div>
            <div id='co_share__button--sms' className='co_share__button co_share__button--sms' onClick={() => this.goToUrl(`sms:${phone}`)}>
              <div className='co_share__button-icon' style={{ backgroundImage: `url(${smsIcon})` }} />
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    shareTitle: PropTypes.string,
    shareSubtitle: PropTypes.string,
    setShareButtonsVisible: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/coffee/components/last/ShareButton.js